import inMemoryJWT from "./inMemoryJWT";
import Roles from "./Roles";
import CryptoJS from "crypto-js";

export const REACT_APP_BACK_PATH = process.env.REACT_APP_BACK_PATH || `http://localhost:${ process.env.REACT_APP_BACK_PORT || 5000}`;
export const REACT_APP_ENCRYPT_PASSPHRASE = process.env.REACT_APP_ENCRYPT_PASSPHRASE;
const REACT_APP_EXCHANGE_PASSPHRASE = process.env.REACT_APP_EXCHANGE_PASSPHRASE || REACT_APP_ENCRYPT_PASSPHRASE;

const defaultOptions: RequestInit = {
    headers: new Headers({
        'Content-Type': 'application/json; charset=UTF-8'
    }),
    mode: 'cors',
    credentials: 'include'
};

const CustomAuthProvider = {

    init: (setTokenEndpoint) => {
        return inMemoryJWT.init(`${REACT_APP_BACK_PATH}/refresh-token`, setTokenEndpoint);
    },

    // called when the user attempts to log in
    login: async ({ username, password }) => {
        const passwordEncrypted = CryptoJS.HmacSHA512(password, REACT_APP_ENCRYPT_PASSPHRASE).toString(CryptoJS.enc.Base64);
        const passwordEncoded = CryptoJS.AES.encrypt(passwordEncrypted, REACT_APP_EXCHANGE_PASSPHRASE).toString(CryptoJS.enc.UTF8);
        return fetch(new Request(`${REACT_APP_BACK_PATH}/authentificate`, {
            ...defaultOptions,
            body: JSON.stringify({ username, password: passwordEncoded }),
            method: 'POST'
        })).then((response) => {
            if (response.status < 200 || response.status >= 300) {
                return Promise.reject();
            } else {
                return response.json();
            }
        }).then(({ token, expiresIn, user }) => {
            return inMemoryJWT.setToken(token, expiresIn, user);
        }).catch((err) => {
            return Promise.reject(err ? "resources.login.back" : undefined);
        });
    },
    /**
     * called when the user clicks on the logout button
     */
    logout: async () => {
        inMemoryJWT.ereaseToken();
        fetch(new Request(`${REACT_APP_BACK_PATH}/logout`, defaultOptions)).catch(() => {
            return;
        });// don't await this fetch else if no back office then we can see empty screen
        return Promise.resolve();
    },
    /** 
     * called when the API returns an error
     */
    checkError: ({ status }) => {
        if (status === 401 || status === 403) {
            inMemoryJWT.ereaseToken();
            return Promise.reject();
        }
        return Promise.resolve()
    },
    /**
     * called when the user navigates to a new location, to check for authentication
     */
    checkAuth: () => {
        return inMemoryJWT.getToken() ? Promise.resolve() : Promise.reject();
    },
    /**
     * called when the user navigates to a new location, to check for permissions / roles
     */
    getPermissions: async () => {
        return Promise.resolve({
            permissions: [{ action: ["edit"], resource: "user", record: { id: inMemoryJWT.getId() } }],
            roles: [inMemoryJWT.getRole()]
        });
    },

    /**
     * 
     */
    getIdentity: async () => {
        return fetch(new Request(`${REACT_APP_BACK_PATH}/identity`, defaultOptions)).then((response) => {
            return response.json();
        }).then(({ id, fullname, avatar }) => {
            return {
                id,
                fullName: fullname,
                avatar
            }
        }).catch(() => {
            return { id: inMemoryJWT.getId() };
        });
    },

    /** Get roles */
    getRoles: () => {
        return Promise.resolve(Roles);
    },

    getId: () => inMemoryJWT.getId(),

    getRole: () => inMemoryJWT.getRole(),

    getRoleEditable: () => inMemoryJWT.getRoleEditable()
};

export default CustomAuthProvider;